/* Search within existing choices; checkbox values and Shopify filtering stay intact. */
(() => {
  if (customElements.get('cs-filter-search')) return;
  customElements.define('cs-filter-search', class extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('input');
      if (!input || input.dataset.bound) return;
      input.dataset.bound = 'true';
      input.addEventListener('input', event => { event.stopPropagation(); this.filter(input.value); });
      input.addEventListener('search', event => { event.stopPropagation(); this.filter(input.value); });
      input.addEventListener('keydown', event => { if (event.key === 'Enter') event.preventDefault(); });
    }
    filter(value) {
      const list = this.nextElementSibling;
      if (!list || list.tagName !== 'UL') return;
      const query = value.trim().toLocaleLowerCase();
      let matches = 0;
      list.classList.toggle('cs-filter-searching', !!query);
      [...list.children].forEach(row => {
        const input = row.querySelector('input[type=checkbox]');
        const label = row.querySelector('.facet-checkbox__text-label');
        const match = !query || (label?.textContent || input?.value || row.textContent).toLocaleLowerCase().includes(query);
        const visible = match || !!input?.checked;
        if (match) matches++;
        row.classList.toggle('cs-filter-match', !!query && visible);
        row.classList.toggle('cs-filter-no-match', !!query && !visible);
      });
      this.querySelector('[role=status]').textContent = query && !matches ? 'No matching options. Selected options remain visible.' : '';
    }
  });
})();
